export default "__VITE_ASSET__R0_5XQij__"